import type { AnalyticsEvent, AnalyticsEventPageProperties } from "@octopusdeploy/portal-analytics";
import type { UnknownPageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { Workflow } from "~/workflows/workflows";

interface WorkflowCancelledEvent extends AnalyticsEvent<"Workflow Cancelled">, Partial<AnalyticsEventPageProperties> {
    WorkflowId: string;
    WorkflowInstanceId: string;
    WorkflowType: "drawer" | "dialog";
    ["Duration (ms)"]: number;
}

interface WorkflowCancelledEventArguments {
    workflow: Workflow<unknown, unknown>;
    workflowInstanceId: string;
    pageRegistration: UnknownPageRegistration | null;
    durationInMs: number;
}

export function createWorkflowCancelledEvent({ workflow, workflowInstanceId, pageRegistration, durationInMs }: WorkflowCancelledEventArguments): WorkflowCancelledEvent {
    const pageFields: AnalyticsEventPageProperties | undefined =
        pageRegistration === null
            ? undefined
            : {
                  "Page Id": pageRegistration.pageId,
                  "Page Area": pageRegistration.pageArea.mainArea,
              };
    return {
        eventName: "Workflow Cancelled",
        WorkflowId: workflow.workflowId,
        WorkflowType: workflow.workflowType,
        WorkflowInstanceId: workflowInstanceId,
        "Duration (ms)": durationInMs,
        ...pageFields,
    };
}
